export const buildImportSummary = (preview) => ({
  updates: preview?.updates?.length ?? 0,
  inserts: preview?.inserts?.length ?? 0,
  newBands: preview?.newBands?.length ?? 0,
  activeChanges: preview?.activeStateChanges?.length ?? 0,
  unknown: preview?.unknownKatos?.length ?? 0,
  errors: preview?.errors?.length ?? 0,
});

export const listApprovedInserts = (preview, approvedBandKeys) => {
  const newBandKeys = new Set((preview?.newBands ?? []).map((b) => b.columnKey));
  const approved = approvedBandKeys instanceof Set ? approvedBandKeys : new Set(approvedBandKeys ?? []);
  return (preview?.inserts ?? []).filter((ins) => {
    if (!newBandKeys.has(ins.columnKey)) return true;
    return approved.has(ins.columnKey);
  });
};

export const buildCommitRequestFromPreview = (preview, { approvedNewBandKeys }) => {
  const approved = new Set(approvedNewBandKeys ?? []);
  const newBands = (preview?.newBands ?? []).filter((b) => approved.has(b.columnKey));
  return {
    approvedNewBandKeys: [...approved],
    updates: preview?.updates ?? [],
    inserts: preview?.inserts ?? [],
    activeStateChanges: preview?.activeStateChanges ?? [],
    newBands,
  };
};
